<template>
    <div>
        <div class='mcf-page-background'></div>
        <div class="mcf-page-editor">
            <div class="mcf-page-editor-form">
                <div class="mcf-page-editor-header">
                    <label>Modifier les informations du produit</label>
                </div>
                <div class="mcf-page-editor-menu">
                    <button @click="bt_save">
                        <i class="fa fa-save"></i>
                        <label>Enregistrer</label>
                    </button>
                    <button @click="bt_cancel">
                        <i class="fa fa-close"></i>
                        <label>Annuler</label>
                    </button>
                </div>
                <div class="mcf-page-editor-content">
                    <div class="mcf-page-editor-title">
                        <label><i class='fa fa-circle-info'></i> Informations générales</label>
                    </div>
                    <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-text">
                            <label>Référence</label>
                            <input type="text" v-model="prod.reference" placeholder="" :disabled="account.setting.product_is_reference_auto==1">
                        </div>
                        <div class="mcf-page-editor-column-select" v-if="prod.id_main=='00000000-0000-0000-0000-000000000000'">
                            <label>Type de produit</label>
                            <select v-model="prod.product_type">
                                <option value="STD">Produit standard</option>
                                <option value="VAR">Produit variable</option>
                            </select>
                        </div>
                    </div>
                    <div class="mcf-page-editor-line">
                        <div class="mcf-page-editor-column-text">
                            <label>Description</label>
                            <textarea type="text" v-model="prod.label" placeholder=""></textarea>
                        </div>
                    </div>
                    <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-text">
                            <label>Famille</label>
                            <input type="text" v-model="prod.family" placeholder="" list="lstfamilies">
                            <datalist id="lstfamilies">
                                <option v-for="fam of prod.lists.families" :key="fam.family" :value="fam.family">{{fam.family}}</option>
                            </datalist>
                        </div>
                        <div class="mcf-page-editor-column-text">
                            <label>Sous-famille</label>
                            <input type="text" v-model="prod.subfamily" placeholder="" list="lstsubfamilies">
                            <datalist id="lstsubfamilies">
                                <option v-for="sfam of prod.lists.subfamilies" :key="sfam.subfamily" :value="sfam.subfamily">{{sfam.subfamily}}</option>
                            </datalist>
                        </div>
                    </div>
                    <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-text">
                            <label>Marque</label>
                            <input type="text" v-model="prod.brand" placeholder="" list="lstbrands">
                            <datalist id="lstbrands">
                                <option v-for="br of prod.lists.brands" :key="br.brand" :value="br.brand">{{br.brand}}</option>
                            </datalist>
                        </div>
                        <div class="mcf-page-editor-column-text">
                            <label>Code à barre</label>
                            <input type="text" v-model="prod.qrcode" placeholder="">
                        </div>
                    </div>
                    <div class="mcf-page-editor-title" v-if="prod.product_type=='VAR'">
                        <label><i class='fa fa-circle-info'></i> Attributs du produit variable</label>
                    </div>
                    <div class="mcf-page-editor-line" v-if="prod.product_type=='VAR'">
                        <table class="mcf-table-salelines" style="padding:0;margin:0;width:100%;margin-top:20px;">
                            <thead>
                                <tr>
                                    <th>Type</th>
                                    <th>Libellé</th>
                                    <th>Choix (séparé par ";")</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="at of prod.lists.attributes.filter(x=>x.is_deleted==0)" :key="at.id">
                                    <td>
                                        <select v-model="at.vtype">
                                            <option value="TEXT">Texte</option>
                                            <option value="COLOR">Couleur (non disponible)</option>
                                        </select>
                                    </td>
                                    <td><input type="text" v-model="at.label"></td>
                                    <td><input type="text" v-model="at.choices"></td>
                                    <td>
                                        <button @click="bt_attribute_save(at)"><i class="fa fa-save"></i></button>
                                        <button @click="bt_attribute_delete(at)"><i class="fa fa-trash"></i></button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <button @click="bt_attribute_new">Nouveau</button>
                    </div>
                    <div class="mcf-page-editor-title">
                        <label><i class='fa fa-circle-info'></i> Tarification</label>
                    </div>
                    <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-text">
                            <label>Prix d'achat</label>
                            <input @change="set_selling_price" type="number" v-model="prod.buying_price" placeholder="">
                        </div>
                        <div class="mcf-page-editor-column-text">
                            <label>Coefficient de marge</label>
                            <input @change="set_selling_price" type="number" v-model="prod.coef_margin" placeholder="">
                        </div>
                    </div>
                    <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-text">
                            <label>Prix de vente</label>
                            <input @change="set_coef_margin" type="number" v-model="prod.selling_price" placeholder="">
                        </div>
                        <!-- <div class="mcf-page-editor-column-text">
                            <label>Saisie libre du prix de vente</label>
                            <input type="checkbox" v-model="prod.is_selling_price_free" id="issellingpricefree">
                            <label for="issellingpricefree"></label>
                        </div> -->
                    </div>
                    <div class="mcf-page-editor-title">
                        <label><i class='fa fa-circle-info'></i> Stock</label>
                    </div>
                    <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-text">
                            <label>Gérer les stocks ?</label>
                            <input type="checkbox" v-model="prod.is_qty_managed" id="isqtymanaged">
                            <label for="isqtymanaged"></label>
                        </div>
                        <div class="mcf-page-editor-column-text">
                            <label>Réservable en ligne ?</label>
                            <input type="checkbox" v-model="prod.is_bookable" id="isbookable">
                            <label for="isbookable"></label>
                        </div>
                    </div>
                    <div class="mcf-page-editor-title" v-if="prod.is_bookable==1">
                        <label><i class='fa fa-circle-info'></i> Paramètres pour la boutique en ligne</label>
                    </div>
                    <div class="mcf-page-editor-line" v-if="prod.is_bookable==1">
                        <div class="mcf-page-editor-column-text">
                            <label>Description détaillée</label>
                            <textarea type="text" v-model="prod.web_description" placeholder=""></textarea>
                        </div>
                    </div>
                    <div class="mcf-page-editor-line-2" v-if="prod.is_bookable==1">
                        <div class="mcf-page-editor-column-text">
                            <label>Libellé de l'option</label>
                            <input type="text" v-model="prod.opt1_label" placeholder="">
                        </div>
                        <div class="mcf-page-editor-column-text">
                            <label>Prix de l'option</label>
                            <input type="number" v-model="prod.opt1_price" placeholder="">
                        </div>
                    </div>
                    <div class="mcf-page-editor-line-2" v-if="prod.is_bookable==1">
                        <div class="mcf-page-editor-column-text">
                            <label>Nombre de caractères maximum</label>
                            <input type="number" v-model="prod.opt1_nb_max_car" placeholder="">
                        </div>
                    </div>
                    <div class="mcf-page-editor-line" v-if="prod.is_bookable==1">
                        <div class="mcf-page-editor-column-text">
                            <label>Description de l'option</label>
                            <textarea type="text" v-model="prod.opt1_description" placeholder=""></textarea>
                        </div>
                    </div>
                    <!-- <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-text">
                            <label>Travée</label>
                            <input type="text" v-model="prod.bay" placeholder="">
                        </div>
                        <div class="mcf-page-editor-column-text">
                            <label>Casier</label>
                            <input type="text" v-model="prod.rack" placeholder="">
                        </div>
                    </div> -->
                    <div class="mcf-page-editor-title">
                        <label><i class='fa fa-circle-info'></i> Comptabilité</label>
                    </div>
                    <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-text">
                            <label>Compte comptable</label>
                            <input type="text" v-model="prod.account_number" placeholder="">
                        </div>
                    </div>
                    <div class="mcf-page-editor-line-3">
                        <div class="mcf-page-editor-column-text">
                            <label>Taxe 1</label>
                            <input @change="set_tax(1)" type="checkbox" v-model="prod.is_tax1" id="istax1">
                            <label for="istax1"></label>
                        </div>
                        <div class="mcf-page-editor-column-text">
                            <label>Taxe 2</label>
                            <input @change="set_tax(2)" type="checkbox" v-model="prod.is_tax2" id="istax2">
                            <label for="istax2"></label>
                        </div>
                        <div class="mcf-page-editor-column-text">
                            <label>Taxe 3</label>
                            <input @change="set_tax(3)" type="checkbox" v-model="prod.is_tax3" id="istax3">
                            <label for="istax3"></label>
                        </div>
                    </div>
                    <div class="mcf-page-editor-title">
                        <label><i class='fa fa-circle-info'></i> Commentaire</label>
                    </div>
                    <div class="mcf-page-editor-line">
                        <div class="mcf-page-editor-column-text">
                            <label>Commentaire</label>
                            <textarea type="text" v-model="prod.note" placeholder=""></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import apiproduct from "@/core/data/product";
import uploadfilebox2 from "@/core/controls/ui-uploadfilebox2";

export default {
    props:{
        account:Object,
        product:Object,
        cancel:Function,
        save:Function
    },
    data(){
        return {
            prod: this.product
        };
    },
    created() {
        this.prod.is_qty_managed = (this.prod.is_qty_managed==1);
        this.prod.is_bookable = (this.prod.is_bookable==1);
        this.prod.is_selling_price_free = (this.prod.is_selling_price_free==1);
        this.prod.is_tax1 = (this.prod.is_tax1==1);
        this.prod.is_tax2 = (this.prod.is_tax2==1);
        this.prod.is_tax3 = (this.prod.is_tax3==1);
    },
    methods:{
        set_coef_margin: function(){
            if (this.prod.buying_price==0){
                this.prod.coef_margin = 0;
            }else{
                this.prod.coef_margin = Number(this.prod.selling_price / this.prod.buying_price).toFixed(2);
            }
        },
        set_selling_price: function(){
            this.prod.selling_price = Number(this.prod.buying_price * this.prod.coef_margin).toFixed(2);
        },
        set_tax: function(val){
            switch(val){
                case 1:
                    // this.prod.is_tax1 = !this.prod.is_tax1;
                    this.prod.is_tax2 = false;
                    this.prod.is_tax3 = false;                    
                    break;
                case 2:
                    this.prod.is_tax1 = false;
                    // this.prod.is_tax2 = !this.prod.is_tax2;
                    this.prod.is_tax3 = false;
                    break;
                case 3:
                    this.prod.is_tax1 = false;
                    this.prod.is_tax2 = false;
                    // this.prod.is_tax3 = !this.prod.is_tax3;
                    break;
            }
        },
        bt_cancel:function(){
            this.cancel();
        },
        bt_save:function(){
            if (!isNaN(parseFloat(this.prod.buying_price))==false){
                this.prod.buying_price = 0;
            }
            if (!isNaN(parseFloat(this.prod.selling_price))==false){
                this.prod.selling_price = 0;
            }
            if (!isNaN(parseFloat(this.prod.coef_margin))==false){
                this.prod.coef_margin = 0;
            }
            this.save(this.prod);
        },
        bt_attribute_new: async function(){
            var pkgattr = await apiproduct.attribute_new(this.prod.id);
            if (pkgattr.code==0){
                this.prod.lists.attributes.push(pkgattr.data);
            }
        },
        bt_attribute_save: async function(o){
            await apiproduct.attribute_save(o);
        },
        bt_attribute_delete: async function(o){
            o.is_deleted=1;
            await apiproduct.attribute_save(o);
        },
         bt_upload_logo: async function(){
            var tmain = this;
            var info = await uploadfilebox2.show({icon:'fa fa-info-circle',extension:'image/*',title:'Veuillez insérer une image',id:tmain.prod.id});
            if (info.action == 'upload'){
                await apiproduct.file_upload(tmain.prod.id,info.file);
                console.log(info);
            }
        }
    }
}
</script>